import { Component, Output, EventEmitter, ElementRef, ViewChild, HostListener, Input, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { RouterModule } from '@angular/router'; // 👈 AJOUT
import { ActivatedRoute } from '@angular/router';
import { WalletService } from '../services/wallet.service';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SlugService } from '../services/slug.service';
import { ChangeDetectorRef } from '@angular/core';

export const CHAIN_MAP: Record<number, { icon: string; name: string }> = {
  1: { icon: 'assets/chains/ethereum-eth-logo.svg', name: 'Ethereum' },
  42161: { icon: 'assets/chains/arbitrum-arb-logo.svg', name: 'Arbitrum' },
  137: { icon: 'assets/chains/polygon-matic-logo.svg', name: 'Polygon' },
  56: { icon: 'assets/chains/bnb-bnb-logo.svg', name: 'BNB Chain' },
};
@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, TranslateModule],
  templateUrl: './side-nav.component.html',
})
export class SideNavComponent {
  constructor(private translate: TranslateService, private route: ActivatedRoute, private wallet: WalletService, private router: Router, private slugSvc: SlugService, private cdr: ChangeDetectorRef,) { }

  @Output() currencyChange = new EventEmitter<string>();
  @Output() networkChange = new EventEmitter<number>();
  @Input() mode: 'swap' | 'bridge' | null = null; // 👈 nouveau
  @Input() selectedNetwork: number = 1;
  ngOnInit() {
    this.loadLanguages();
  }


  showNetworkDropdown = false;
  settingsOpen = false;
  selectedLanguage: string = localStorage.getItem('lang') || 'en';
  selectedCurrency: string = localStorage.getItem('currency') || 'EUR';
  languages: { code: string; label: string }[] = [];
  /*currencies = ['USD', 'EUR', 'XOF', 'GBP', 'CAD', 'BTC', 'ETH'];*/
  currencies = ['USD', 'EUR', 'GBP', 'CAD', 'INR', 'IDR', 'VND', 'TRY', 'NGN', 'BRL', 'ZAR', 'THB', 'MYR','PHP'];
  readonly CHAIN_MAP = CHAIN_MAP;

  toggleSettings() {
    this.settingsOpen = !this.settingsOpen;
  }

  toggleTheme() {
    const body = document.body;
    if (body.classList.contains('light-mode')) {
      body.classList.remove('light-mode');
      body.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      body.classList.remove('dark-mode');
      body.classList.add('light-mode');
      localStorage.setItem('theme', 'light');
    }
  }
  get isAlertsRoute(): boolean {
    return this.router.url.includes('/alerts');
  }
  get isDisclaimer(): boolean {
    return this.router.url.includes('/disclaimer');
  }
  get isAbout(): boolean {
    return this.router.url.includes('/a-propos');
  }

  get isBlog(): boolean {
    return this.router.url.includes('/blog');
  }


  async selectNetwork(id: number) {
    try {
      if (this.wallet.isConnected()) {   // ⚡ ajoute une méthode helper dans ton WalletService
        await this.wallet.switchChain(id);
      }
    } catch (e) {
      console.error('Switch chain failed', e);
    } finally {
      this.selectedNetwork = id;
      this.networkChange.emit(id); // notifie le parent dans tous les cas
    }
  }

   get isBridge(): boolean {
    if (this.mode) return this.mode === 'bridge';
    const qp = this.route.snapshot.queryParamMap.get('bridge'); // déjà utilisé dans ton code
    return (qp !== null && qp !== '0') || this.router.url.includes('/bridge');
  }

  get isSwap(): boolean {
    if (this.mode) return this.mode === 'swap';
    return !this.isBridge;
  }

  get invBridgeLogo(): string {
    return this.isSwap ? 'text-purple-500' : 'text-blue-500';
  }

  get invBridgeGradient(): string {
    return this.isSwap
      ? 'bg-gradient-to-r from-purple-300 via-purple-500 to-indigo-600'
      : 'bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600';
  }
  getCurrencyLabel(code: string): string {
    return this.translate.instant(`currency.${code}`) || code;
  }


  loadLanguages() {
    const languageFiles = [
      'en.json', 'es.json', 'fr.json', 'pt.json', 'it.json',
      'hi.json', 'bn.json', 'ta.json', 'te.json', 'mr.json',
      'id.json', 'vi.json', 'tr.json', 'km.json',
      'th.json', 'ms.json', 'tl.json', 'zu.json', 'af.json'
    ];

    const labels: Record<string, string> = {
      en: 'English',
      es: 'Español',
      fr: 'Français',
      pt: 'Português',
      it: 'Italiano',
      hi: 'हिन्दी',
      bn: 'বাংলা',
      ta: 'தமிழ்',
      te: 'తెలుగు',
      mr: 'मराठी',
      id: 'Bahasa Indonesia',
      vi: 'Tiếng Việt',
      tr: 'Türkçe',
      km: 'ខ្មែរ',
      th: 'ไทย',              // Thai
      ms: 'Bahasa Melayu',     // Malay (Malaysia)
      tl: 'Filipino',
      zu: 'isiZulu',           // Zulu (South Africa)
      af: 'Afrikaans'
    };

    this.languages = languageFiles.map(file => {
      const code = file.replace('.json', '');
      return { code, label: labels[code] || code };
    });

    if (!this.languages.some(lang => lang.code === this.selectedLanguage)) {
      this.selectedLanguage = this.languages[0]?.code || 'en';
      this.changeLanguage(this.selectedLanguage);
    }
  }


  changeCurrency(code: string) {
    this.selectedCurrency = code;
    localStorage.setItem('currency', code);
    this.currencyChange.emit(code);
  }

  async changeLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
    this.selectedLanguage = lang;

    // URL actuelle
    const tree = this.router.parseUrl(this.router.url);
    const segments = tree.root.children['primary']?.segments.map(s => s.path) || [];

    // pattern /:lang/:slug(/...?) → on tente de traduire le slug
    const SUP = ['en', 'es', 'fr', 'pt', 'it', 'hi', 'id', 'vi', 'tr', 'th', 'ms'];
    if (segments.length >= 2 && SUP.includes(segments[0])) {
      const fromLang = segments[0];
      const currentSlug = segments[1];

      let targetSlug = await this.slugSvc.translateSlug(currentSlug, fromLang, lang);
      if (!targetSlug) {
        // fallback: si pas trouvé dans l’index, on garde le même slug
        targetSlug = currentSlug;
      }

      // reconstruire l’URL en remplaçant langue + slug
      const rest = segments.slice(2).join('/');
      const next = `/${lang}/${targetSlug}${rest ? '/' + rest : ''}`;
      this.router.navigateByUrl(next, { replaceUrl: true });
      return;
    }

    // sinon (pages sans slug), on se contente de remplacer la langue
    const rx = /^\/(en|es|fr|pt|it|hi|id|vi|tr|th|ms)(\/|$)/;
    const url = this.router.url;
    const next = rx.test(url) ? url.replace(rx, `/${lang}$2`) : `/${lang}${url.startsWith('/') ? '' : '/'}${url}`;
    this.router.navigateByUrl(next, { replaceUrl: true });
 
    this.cdr.detectChanges();
  }

    ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedNetwork'] && changes['selectedNetwork'].currentValue != null) {
      // on s’assure qu’on reflète bien la valeur du parent
      this.selectedNetwork = Number(changes['selectedNetwork'].currentValue);
    }
  }
  isDarkMode(): boolean {
    return document.body.classList.contains('dark-mode');
  }
}
